module.exports = __webpack_public_path__ + "static/media/avatar-16.66991e46.svg";